<template>
  <b-sidebar
      :id="drawerId"
      title="Sidebar"
      v-model="open"
      bg-variant="white"
      width="560px"
      sidebar-class="border"
      shadow
      right
      no-header
  >
    <template #default="{  }">
      <div class="d-flex align-items-center justify-content-between ps-3 border-bottom">
        <div class="drawer-title">{{ _.upperCase($t('balancing_payments.singular')) }}</div>
        <b-button variant="white" @click="closeDrawer">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                fill="#454646"/>
          </svg>
        </b-button>
      </div>
      <div class="p-3 d-grid">
        <Loader :loading="loading" no-axios>
          <div class="" v-if="model && model.id">
            <div v-if="model.balancing_transaction">
              <div class="row">
                <div class="col-md-6 mb-16">
                  <div><span class="heading-font-5">No. Balancing: </span>
                    <router-link :to="`/balancings?balancing_show__id=${model.balancing_transaction.id}`" target="_blank">
                      {{ model.balancing_transaction.id }}
                    </router-link>
                  </div>
                </div>
                <div class="col-md-6 mb-16">
                  <div><span class="heading-font-5">No. Bongkar: </span>
                    <router-link :to="`/unloads/${model.balancing_transaction.sale_order.id}`" target="_blank">
                      {{ model.balancing_transaction.sale_order.id }}
                    </router-link>
                  </div>
                </div>
                <div class="col-md-6 mb-16">
                  <div><span class="heading-font-5">No. Folder: </span>
                    <router-link :to="`/tickets/${model.balancing_transaction.sale_order.ticket_id}`" target="_blank">
                      {{ model.balancing_transaction.sale_order.ticket_id }}
                    </router-link>
                  </div>
                </div>
                <div class="col-md-6 mb-16">
                  <div>
                    <span class="heading-font-5">
                      Purchase Ref<i class="bx bx-info-circle"
                                     v-tooltip="{
                content: `Referensi PI, PO, DP, dari<br/> platform eksternal`,
                html: true,
                theme: 'info-tooltip',
                placement: 'bottom',
               }"></i>: </span>
                    {{ purchaseInvoices }}
                  </div>
                </div>
                <div class="col-md-6 mb-16">
                  <div><span class="heading-font-5">No. Penjualan: </span>
                    <router-link :to="`/sale_notes/${model.balancing_transaction.sale_order.id}`" target="_blank">
                      {{ model.balancing_transaction.sale_order.id }}
                    </router-link>
                  </div>
                </div>
              </div>
              <hr/>
              <div class="section-title">Detail Pembayaran</div>
              <div class="row mt-12px">
                <div class="col-md-6">
                  <div class="font-size-500 text-slate-800">Pengirim</div>
                  <div>{{ model.from_bank_account.customer.name }}</div>
                  <div>
                    {{ bankAccountFormat(model.from_bank_account) }}
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="font-size-500 text-slate-800">Penerima</div>
                  <div>{{ model.to_bank_account.customer.name }}</div>
                  <div>
                    {{ bankAccountFormat(model.to_bank_account) }}
                  </div>
                </div>
              </div>
              <hr/>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-12 mb-16">
                      <div>
                        <div class="font-size-500 text-slate-800 mb-4px">Status Balancing</div>
                        <div><span v-html="status" :class="statusStyle"></span></div>
                      </div>
                    </div>
                    <div class="col-md-12 mb-16">
                      <div>
                        <div class="font-size-500 text-slate-800 mb-4px">{{ lodash.startCase($t('balancing_payments.adjustment')) }}</div>
                        {{ $numeral(model.balancing_transaction.adjustment).format("$ 0,0.[00]") }}
                      </div>
                    </div>
                    <div class="col-md-12 mb-16">
                      <div>
                        <div class="font-size-500 text-slate-800 mb-4px">Nominal Balancing</div>
                        <div class="font-size-600 text-slate-600">
                          {{ $numeral(model.balancing_transaction.total_debt).format("$ 0,0.[00]") }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="col-md-12 mb-16">
                    <div>
                      <div class="font-size-500 text-slate-800 mb-4px">Jumlah Pembayaran</div>
                      <div>{{ $numeral(Math.abs(model.nominal)).format("$ 0,0.[00]") }}</div>
                    </div>
                  </div>
                  <div class="col-md-12 mb-16">
                    <div>
                      <div class="font-size-500 text-slate-800 mb-4px">
                        {{ _.startCase($t('balancing_payments.paid_at')) }}
                      </div>
                      <div>{{ $moment.utc(model.paid_at).local().format('DD MMMM YYYY') }}</div>
                    </div>
                  </div>
                  <div class="col-md-12 mb-16">
                    <div>
                      <div class="font-size-500 text-slate-800 mb-4px">
                        {{ _.startCase($t('balancing_payments.invoice_number')) }}
                      </div>
                      <div>{{ model.id }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div>
                    <div class="font-size-500 text-slate-800 mb-4px">Bukti Pembayaran</div>
                    <div class="font-size-600 text-slate-600">
                      <span v-if="!(model.transfer_slip || model.optional_files.length > 0)">-</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 mb-3" v-if="model.transfer_slip">
                  <b-form-group
                      :label="`${lodash.upperFirst($t('balancing_payments.transfer_slip'))}`"
                  >
                    <attachment-preview
                        :key="`transfer-slip-${model.transfer_slip.id}`"
                        :format="model.transfer_slip.extension"
                        :preview="model.transfer_slip.url"
                        :file="model.transfer_slip"
                        class="mt-3"
                    />
                  </b-form-group>
                </div>
                <template v-for="(optional_file, key) in model.optional_files.filter((r) => r._action !== 'delete')">
                  <div :key="`optional_files.key.${key}`" class="col-md-6 mb-3">
                    <b-form-group
                        :label="lodash.upperFirst($t('balancing_payments.optional_file')) + ` - ${key + 1}`"
                    >
                      <attachment-preview
                          :key="`transfer-slip-${model.transfer_slip.id}`"
                          :format="optional_file.extension"
                          :preview="optional_file.url"
                          :file="optional_file"
                          class="mt-3"
                      />
                    </b-form-group>
                  </div>
                </template>
              </div>
              <div class="row">
                <div class="col-md-12 mb-16">
                  <div>
                    <div class="font-size-500 text-slate-800 mb-4px">Berita Acara</div>
                    <div class="text-neutral-900">
                      <span v-if="model.description" v-html="model.description"></span>
                      <span v-else>-</span>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </Loader>
      </div>
      <div class="d-flex justify-content-end align-items-center border-top p-12px" v-if="!loading">
        <b-button variant="success" @click="exportModel">Unduh</b-button>
      </div>
    </template>
  </b-sidebar>
</template>
<script>
/* eslint-disable vue/no-unused-components */
import BaseDrawer from "@/components/drawers/base-drawer.vue";
// import NumeralInput from "@/components/inputs/numeral.vue";
import Loader from "@/components/widgets/loader.vue";
import MultiselectAjax from "@/components/inputs/vue-multiselect-ajax.vue";
import CustomerCreateModal from "@/components/modals/customer-create.vue";
import BankAccountCreate from "@/components/modals/bank-account-create.vue";
import AttachmentPreview from "@/components/inputs/attachment-preview.vue";
import Swal from "sweetalert2";

export default {
  name: "balancing-payment-show-drawer",
  extends: BaseDrawer,
  components: {
    AttachmentPreview,
    BankAccountCreate, CustomerCreateModal, MultiselectAjax,
    Loader,
  },
  data() {
    return {
      model: null,
      loading: true,
      allowUpdate: false,
      updateStatus: 'updated',
      allowUpdateTimeout: null,
    }
  },
  watch: {

  },
  computed: {
    updateStatusMessage() {
      if (this.updateStatus === 'updated') return `${this.lodash.upperFirst(this.$t('updated_at'))} ${this.$moment.utc(this.salesInvoice.updated_at).local().format('DD MMMM YYYY hh:mm')}`
      if (this.updateStatus === 'updating') return this.lodash.upperFirst(this.$t('updating'))
      return this.lodash.upperFirst(this.$t('failed_to_update'))
    },
    status() {
      const remaining_debt = this.model.balancing_transaction.remaining_debt || 0
      if (remaining_debt === 0) return this.lodash.upperFirst(this.$t('paid off'))
      return remaining_debt > 0 ?
          this.lodash.upperFirst(this.$t('underpaid {nominal}', {nominal: `<br>${this.$numeral(remaining_debt).format('$ 0,0.[00]')}`})) :
          this.lodash.upperFirst(this.$t('balancing_payments.overpaid {nominal}', {nominal: `<br>${this.$numeral(Math.abs(remaining_debt)).format('$ 0,0.[00]')}`}))
    },
    statusStyle() {
      const remaining_debt = this.model.balancing_transaction.remaining_debt || 0
      if (remaining_debt === 0) return 'text-success'
      return remaining_debt > 0 ? 'text-warning' : 'text-success'
    },
    isDepositGood() {
      return this.model.balancing_transaction?.sale_order?.type === 'deposit_goods'
    },
    purchaseInvoices(){
      if (this.isDepositGood) {
          return this.model.invoice_number;
      }
      const ids = this.model.balancing_transaction.sale_order.sale_items
          .map(item => (
              item.purchase_item.purchase_order.paymentables
                  .map(paymentable => paymentable.payment.invoice_number)
          )).flat().filter((id) => !!id);
      const uniqueIds = [...new Set(ids)];
      if(uniqueIds.length === 0){
        return '-';
      }
      return uniqueIds.join(', ');
    }
  },
  methods: {
    exportModel() {
      this.loadingExport = true
      return this.$axios.get(`/payments/${this.model.id}/balancing_payment_export`, {
        responseType: 'blob',
      })
          .then(res => {
            // create file link in browser's memory
            const href = URL.createObjectURL(res.data);

            // create "a" HTML element with href to file & click
            const link = document.createElement('a');
            link.href = href;
            const fileName = `Balancing Payment - ${this.$moment(this.model.paid_at).format('DD MMM YYYY')}.pdf`
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
            return res
          }).catch(() => {
            return Swal.fire({
              title: this.lodash.startCase(this.$t('failed')),
              text: this.lodash.upperFirst(this.$t('download_failed')),
              type: 'danger',
              confirmButtonClass: 'btn btn-danger btn-fill',
              buttonsStyling: false
            })
          }).finally((res) => {
            this.loadingExport = false
            return res
          })
    },
    bankAccountFormat(bank_account) {
      let bankName = bank_account.bank.name;
      let regex = /\(([^)]+)\)/;
      let matches = regex.exec(bankName);
      if (matches) {
        bankName = matches[1];
      }
      return [bank_account.name, bank_account.account_number, bankName].filter(d => !!d).join(' - ');
    },
    fetchModel(modelId) {
      this.loading = true;
      return this.$axios.get(`/payments/${modelId}`, {
        params: {
          with: [
            'paymentable',
            'paymentable.sale_order',
            'paymentable.sale_order.ticket',
            'paymentable.sale_order.trip',
            'paymentable.sale_order.sale_items.purchase_item.purchase_order.paymentables.payment',
            'paymentable.customer',
            'paymentable.profit_share',
            'paymentable.manufacture',
            'from_bank_account.bank',
            'from_bank_account.customer',
            'to_bank_account.bank',
            'to_bank_account.customer',
            'creator',
            'files',
          ].join(','),
        }
      }).then((response) => {
        const {data: {data}} = response;
        this.model = {
          ...data,
          balancing_transaction: data.paymentable || {},
          transfer_slip: data.files.find(v => v.name === 'transfer slip'),
          optional_files: data.files.filter(v => !['transfer slip', 'invoice document'].includes(v.name)),
        };
        this.allowUpdateTimeout = setTimeout(() => {
          this.allowUpdate = true;
        }, 3000);
        return response;
      }).catch((error) => this.failedAlert(error)).finally(() => {
        this.loading = false
      })
    },
    show(modelId) {
      const timeout = this.open ? 200 : 0
      this.closeDrawer();
      window.clearTimeout(this.allowUpdateTimeout);
      setTimeout(() => {
        this.openDrawer();
        this.model = null;
        this.updateStatus = 'updated';
        this.allowUpdate = false;
        this.fetchModel(modelId);
      }, timeout)
    },
  },
}
</script>

<style lang="scss" scoped>
.drawer {
  width: 560px;
}

.drawer-title {
  color: #334155;
  font-size: 16px;
  font-weight: 800;
  line-height: 20px; /* 125% */
  letter-spacing: 0.8px;
}
</style>

<style lang="scss" scoped>
.label {
  color: var(--neutral-800, var(--colors-slate-800, #1E293B));
  font-size: 13px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0.26px;
}

.value {
  color: var(--neutral-600, var(--colors-slate-600, #475569));
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin-block: 4px;
  margin-bottom: 12px;
}

.section-title {
  color: var(--neutral-700, var(--colors-slate-700, #334155));
  font-size: 16px;
  font-style: normal;
  font-weight: 800;
  line-height: 20px; /* 125% */
  letter-spacing: 0.8px;
}
</style>